<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6" id="title-card-authorization">
            Añadir datos Intermedios
          </div>
        </q-card-section>
        <q-card-section class="container-auth q-pt-none q-col-gutter-y-sm">
          <slot name="body">
            <q-form ref="form">
              <div class="row">
                <!--Dato de partida-->
                <div class="divDato col-6">
                  <q-input
                    label="Dato"
                    v-model.number="dato"
                    type="number"
                    outlined
                    class="col-6"
                    :rules="[
                      val =>
                        validateNumberWith2Decimals(val) ||
                        'Número incorrecto, máx 2 decimales.'
                    ]"
                  ></q-input>
                </div>
                <!--fecha-->
                <div class="divFecha col-6">
                  <q-input
                    class="required"
                    outlined
                    label="Fecha"
                    v-model="fecha"
                    mask="date"
                    :rules="['date']"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          ref="qDateProxy"
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date v-model="fecha">
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Cerrar"
                                color="primary"
                                flat
                              ></q-btn>
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                    <template v-slot:error>Fecha no válida.</template>
                  </q-input>
                </div>
              </div>
            </q-form>
          </slot>
        </q-card-section>

        <q-card-actions align="right" class="text-primary container-actions">
          <q-btn
            class="bSecondary"
            flat
            label="Cancelar"
            v-close-popup
            @click="cancel()"
          />
          <q-btn
            label="AÑADIR"
            class="bPrincipal"
            padding="xs lg"
            @click="save()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QDialog, QPopupProxy, QForm } from 'quasar';
import Validation from '@/components/shared/mixins/Validation.js';

export default {
  mixins: [Validation],
  components: {
    QDialog,
    QPopupProxy,
    QForm
  },
  props: {
    value: {
      required: true
    },
    row: Object
  },
  data () {
    return {
      valueLocal: this.value,
      dato: 0,
      fecha: null
    };
  },
  created () {
    this.clean();
    this.dato = this.row.value;
    this.fecha = this.row.date;
  },
  watch: {
    value: {
      handler: function () {
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
        this.clean();
        this.dato = this.row.value;
        this.fecha = this.row.date;
      },
      immediate: true
    }
  },
  methods: {
    cancel () {
      this.$emit('input', false);
    },
    clean () {
      this.dato = 0;
      this.fecha = null;
    },
    save () {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.newDato = {
            value: this.dato,
            date: this.fecha
          };
          if (this.row.hasOwnProperty('position')) {
            this.newDato['position'] = this.row.position;
          }
          this.$emit('input', false);
          this.$emit('saveDato', this.newDato);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.card-authorization {
  min-width: 700px;
  .header {
    padding-top: 18px;
    #title-card-authorization {
      font-family: DINPro;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $azulcabecera;
    }
  }
  .container-actions {
    padding-top: 15px;
  }
  .container-auth {
    .title-option {
      font-family: DINPro;
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #5c5c5c;
      padding-bottom: 20px;
    }
  }
  &::v-deep {
    .q-field--standard .q-field__control:before {
      border-bottom-color: rgba(89, 89, 89, 0.5) !important;
    }
  }
}
.q-dialog__inner {
  div::v-deep {
    border-radius: 12px !important;
  }
}
.q-card {
  padding-left: 40px;
  padding-right: 40px;
}
.divDato {
  padding-right: 15px;
}
</style>
